<template>
  <div class="is-fullwidth">
    <h1 class="is-size-3">{{ $t("page.orders") }}</h1>

    <pagination-control
      :controls="{ itemsPerPage, filter}"
      :pagination="$store.state.orders.pagination"
    />

    <div
      class="table-wrapper"
      ref="tableWrapper"
      v-if="$store.getters['orders/listForTable'].length"
    >
      <button class="button is-info m-b-5" @click="downloadFile(`/orders/export`)">
        <i class="mdi mdi-database-export"></i>
      </button>

      <table class="table m-t-5 is-striped is-fullwidth ws-nowrap" ref="table">
        <thead>
          <tr>
            <th>
              <nuxt-link :to="{ query: querySort('order_number') }">
                {{ $t("form.order_number") }}
                <sort-icon sort-by="order_number" />
              </nuxt-link>
            </th>
            <th>
              <nuxt-link :to="{ query: querySort('company')}">
                {{ $t("form.company") }}
                <sort-icon sort-by="company" />
              </nuxt-link>
            </th>
            <th>
              <nuxt-link :to="{ query:querySort('latest') }">
                {{ $t("form.status") }}
                <sort-icon sort-by="latest" />
              </nuxt-link>
            </th>
            <th>
              <nuxt-link :to="{ query:querySort('created_at') }">
                {{ $t("form.date") }}
                <sort-icon sort-by="created_at" />
              </nuxt-link>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="order in $store.getters['orders/listForTable']" :key="order.id">
            <th>
              <nuxt-link
                :to="
                  localePath({
                    name: 'office-orders-id',
                    params: { id: order.id }
                  })
                "
              >{{ order.order_number }}</nuxt-link>
            </th>
            <td>{{ order.company }}</td>
            <td>{{ order.latest }}</td>
            <td>{{ order.created_at }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>{{$t('message.no_data')}}</div>
    <span
      v-if="showSwipeIcon"
      class="mdi mdi-gesture-swipe-horizontal has-text-primary"
      style="font-size: 25px"
    ></span>

    <pagination class="m-t-5" :meta="$store.state.orders.pagination" />
  </div>
</template>

<script>
export default {
  watchQuery: true,

  async asyncData({ store, query, params }) {
    if (!params.skipReloding) {
      await store.dispatch("orders/fetchOrders", query);
    }

    let objToReturn = {};

    if (query.per_page) {
      objToReturn.itemsPerPage = query.per_page;
    }

    objToReturn.filter = query.filter;

    return objToReturn;
  },

  computed: {
    showSwipeIcon() {
      return (
        this.isMounted &&
        this.$refs.table &&
        this.$refs.table.scrollWidth > this.$refs.tableWrapper.clientWidth
      );
    }
  },

  methods: {
    activeTab(id) {
      switch (id) {
        case 1:
          return (
            !this.$route.query.status ||
            this.$route.query.status === "in_progress"
          );
        case 2:
          this.$route.query.status === "accepted";
        case 3:
          this.$route.query.status === "rejected";
      }
    }
  }
};
</script>




// WEBPACK FOOTER //
// resources/nuxt/pages/office/orders/index.vue